import {Tooltip} from 'antd';
import {get} from 'lodash-es';
import React from 'react';

import {DynamicIcon} from 'components/dynamic-icon';
import {TEntityValue, TFileList} from 'modules/data';
import {ECommonMessages} from 'shared/constants/messages';
import {EFileType} from 'shared/types/files';
import {downloadFile, showMessageFromResponse} from 'shared/utils';
import {generateUrlByFileType} from 'shared/utils/file';

import {IColumnFormatterProps} from '../../table-types';

import './download-file-link.less';

export interface IDownloadFileLinkProps extends IColumnFormatterProps {
    value: TEntityValue;
    stringStructure?: string;
    icon?: string;
    fileType?: EFileType;
    entityName: string;
}

export const DownloadFileLink = ({
    value,
    stringStructure,
    icon,
    fileType = EFileType.FILE,
    entityName,
}: IDownloadFileLinkProps) => {
    const stringStructureValue = stringStructure && get(value, stringStructure);
    const stringStructureFileList = stringStructureValue?.length
        ? stringStructureValue
        : [stringStructureValue]; // emulate array

    const files: TFileList = (() => {
        if (stringStructure) return stringStructureFileList;
        if (Array.isArray(value)) return value;
        return [value];
    })();

    if (!files) return <></>;

    const handleFileDownload = (attachment: any, filename: any) => {
        if (filename && attachment) {
            const url = generateUrlByFileType({type: fileType, id: attachment, entityName, stringStructure});   
            if (!url) return;

            downloadFile(url, filename)
                .then(data => {
                    if (data.status === 200) {
                        showMessageFromResponse({
                            response: data,
                            isError: false,
                            customMessage: ECommonMessages.UPLOAD_FILE_SUCCESS,
                        });
                    }
                })
                .catch(error => {
                    showMessageFromResponse({response: error?.response, isError: true});
                });
        }
    };

    const getComponent = (file: any) => {
        const fileName = fileType === EFileType.SIGNATURE
            ? file?.signatureFileName
            : file?.fileName;

        if (!fileName) return null;

        return (icon ? (
            <Tooltip title={fileName}>
                <DynamicIcon
                    className="download-file-link-icon"
                    type={icon}
                    onClick={() => handleFileDownload(file.attachmentId, fileName)}
                />
            </Tooltip>
        ) : (
            <div
                onClick={() => handleFileDownload(file.attachmentId, fileName)}
                className="download-file-link"
            >
                {fileName}
            </div>
        ));
    };

    return (
        <>
            {files.map((file: any) => getComponent(file))}
        </>
    );
};
